<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>会计代码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
			<div class="handle-box">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText">
				</el-input>&nbsp;
				<el-button type="primary" icon="el-icon-lx-add" class="handle-del mr10" @click="handleAdd">添加记录</el-button>
			</div>
            <el-table
				:data="dataSource.filter(data => !filterText || data.code.toString().includes(filterText.toLowerCase()) || data.name.toLowerCase().includes(filterText.toLowerCase()))"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				size="medium"
				default-expand-all
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column
				  prop="code"
				  label="会计代码"
				  width="280">
				</el-table-column>
				<el-table-column
				  prop="name"
				  label="名称"
				  width="280">
				</el-table-column>
				<el-table-column
				  prop="attributionType"
				  label="属性"
				  width="120" :formatter="attributionTypeFormater">
				</el-table-column>
				<el-table-column
				  prop="extend"
				  label="扩展倍率">
				</el-table-column>
				<el-table-column
				  prop="remark"
				  label="备注">
				</el-table-column>
				<el-table-column label="操作" width="180" align="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="append(node, scope.row)"
						>新增</el-button>
						<el-button
							type="text"
							icon="el-icon-delete"
							class="red"
							@click="remove(node, scope.row)"
							v-if="scope.row.children.length == 0"
						>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="会计代码" prop="code">
					<el-input v-model="form.code"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="属性" prop="attributionType">
					<el-select v-model="form.attributionType" placeholder="请选择属性">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in attributionTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="扩展倍率" prop="extend">
					<el-input v-model="form.extend"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type=textarea :rows=10 v-model="form.remark"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchAccountingTreeData, saveAccounting, deleteAccounting, getAttributionTypeKV} from '../../../api/index';
export default {
    name: 'accounting-code',
    data() {
		let checkNum = (rule, value, callback) => {
			const mailReg = /^[0-9]*$/
			if (value) {
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('编码为数值型'));
				}
			} else {
				callback(new Error('请输入编码'));
			}
		}
        return {
            dataSource: [],
            form: {},
            id: -1,
			title:"",
			editVisible:false,
			isDisabled:false,
			filterText:"",
			rules: {
                code: [{ required: true, message: '请输入会计代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				attributionType: [{ required: true, message: '请输入属性', trigger: 'blur' }]
            },
			controll:{},
			accountingTypeKV:[],
			activeName:"baseTab",
			attributionTypeKV:[]
        };
    },
    created() {
		this.getAttributionType();
        this.getData();
    },
    methods: {
		//获取会计代码属性
		getAttributionType(){
            getAttributionTypeKV().then(res => { 
				if (res.code == 0 ) {
					this.attributionTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//会计属性格式化
		attributionTypeFormater(row, column, cellValue){
			let index = this.attributionTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.attributionTypeKV[index].value;
		},
        // 获取数据
        getData() {
            fetchAccountingTreeData().then(res => { 
				if (res.code == 0 ) {
					this.dataSource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        append(node, data) {
			this.form = {};
			this.$set(this.form, "parentId", data.id);
			this.$set(this.form, "parentName", data.title);
			this.editVisible = true;
		},
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "parentId", undefined);
			this.$set(this.form, "parentName", undefined);
			this.editVisible = true;
		},		
		// 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAccounting(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		getIds(ids, data) {
			ids.push(data.id);
			if (data.children) {
				for(let i = 0; i < data.children.length; i++) {
					this.getIds(ids, data.children[i]);
				}
			}
		},		
		// 删除操作
        remove(node, data) {
            // 二次确认删除
			let confirmStr = '确定要删除 ' + data.name + '(' + data.code + ') 吗？';
            this.$confirm(confirmStr, '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccounting([data.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },		
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
